import { faInfoCircle } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { useNavigate, useParams } from "react-router-dom"
import { ModalContentProps } from "../../types/commonTypes"
import { composeUrl } from "../../utils/utils"
import { LNextButton, SecondChoiseButton } from "../styled/Button.style"
import { Section } from "../styled/Containers.style"
import { IconContainer, LIconContainer } from "../styled/Icon.style"
import { ModalConfirmButton } from "../styled/Modal.style"
import { Vspace } from "../styled/Separators.style"
import { TextDefaultSmall } from "../styled/Text.style"
import { AUTH_CONFIRM_BASE_ROUTH, AUTH_CONFIRM_PATHS } from "../../routes/AuthConfirmRouter"
import { EventCommType, EventValueEnum } from "../../types/communication/communicationDataType"
import { saveCommunicationAct } from "../../store/communication-data/actions"
import { useAppDispatch, useAppSelector } from "../../store/hooks"
import { selectCommunicationData } from "../../store"
import linear_infoModal from '../../assets/img/linear_infoModal.svg'
import { LINEAR_BASE_ROUTE } from "../../routes/linearRouteConstants"

/* istanbul ignore next */
export const CancelAuthorizeConfirmClaimModalContent = ({ close, additionalData }: ModalContentProps<null>) => {
    const dispatch = useAppDispatch();
    const communicationData = useAppSelector(selectCommunicationData)
    const { communication } = communicationData
    const { token } = useParams();
    const navigate = useNavigate();

    const isLinear = communication?.companyName === "LINEAR";

    const evVal = additionalData?.event || EventValueEnum.AUTH_CONFIRM_END_CANCEL

    const endProcessHandler = () => {
        /* istanbul ignore next */
        const linearBaseRoute = `${LINEAR_BASE_ROUTE}/${AUTH_CONFIRM_BASE_ROUTH}`;
        const unipolBaseRoute = AUTH_CONFIRM_BASE_ROUTH;
        const nextPath = composeUrl(token, AUTH_CONFIRM_PATHS.AUTHORIZE_CONFIRM_END_CANCEL, isLinear ? linearBaseRoute : unipolBaseRoute)
        /* istanbul ignore next */
        const newEvent = new EventCommType({ value: evVal })
        /* istanbul ignore next */
        dispatch(saveCommunicationAct({
            events: [newEvent],
        }))
        // Go in any case to the Cancel path
        navigate(nextPath)
    }

    return (
        <>
            <Section>
                {isLinear === false ? <IconContainer>
                    <FontAwesomeIcon icon={faInfoCircle} />
                </IconContainer> : <LIconContainer>
                    <img
                        src={linear_infoModal}
                        alt="Info Modale"
                        style={{ width: "120px" }}
                    />
                </LIconContainer>}
            </Section>

            <Section linear={isLinear}>
                {isLinear === false ? <TextDefaultSmall>Questo passaggio è necessario per procedere con la Constatazione Amichevole digitale.<br /><br />Vuoi tornare indietro per riprovare?</TextDefaultSmall> :
                    <TextDefaultSmall className="LINEAR">Sei sicuro di voler interrompere la procedura di firma digitale?<br /><br />Abbandonando questa operazione, il processo di firma digitale verrà interrotto e non sarà possibile portarlo a termine.</TextDefaultSmall>}
            </Section>

            <Vspace qty={2}></Vspace>

            <Section linear={isLinear}>
                {isLinear === false ? <ModalConfirmButton onClick={close}>TORNO INDIETRO</ModalConfirmButton> : <LNextButton onClick={close}>RIMANI E CONTINUA IL PROCESSO</LNextButton>}
                <Vspace></Vspace>
                {isLinear === false ? <SecondChoiseButton
                    onClick={endProcessHandler}
                >Termina la procedura</SecondChoiseButton> :
                    <LNextButton inverted={true} onClick={endProcessHandler}>ABBANDONA</LNextButton>}
            </Section>

        </>
    )
}
